import AppConstants from '../constants';
import stateProvider from './state-provider';
import movieHelper from './movie-helper';
import publishHelper from './publish-helper';


// Notice: these helpers should treat the redux state as READ-ONLY.
// they should not manipulate or write to the redux state.
// Doing so would cause redux state update thrashing.
// they are intended to interpret and parse the redux state in a read only manner.
// all helper objects should already be a singleton instance.


export default {
  appConst: AppConstants,
  state: stateProvider,
  movie: movieHelper,
  publish: publishHelper,
};
